var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加抄送人",
            visible: _vm.ccToCorpUserVisible,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.ccToCorpUserVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { staticClass: "tel-search" },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { padding: "0 10px" },
                          attrs: { span: 8 }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              size: "small",
                              placeholder: "账号"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.queryToolMyCorp()
                              }
                            },
                            model: {
                              value: _vm.myCorpModel.keyword,
                              callback: function($$v) {
                                _vm.$set(_vm.myCorpModel, "keyword", $$v)
                              },
                              expression: "myCorpModel.keyword"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { padding: "0 10px" },
                          attrs: { span: 8 }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              size: "small",
                              placeholder: "名称"
                            },
                            model: {
                              value: _vm.myCorpModel.corpUserName,
                              callback: function($$v) {
                                _vm.$set(_vm.myCorpModel, "corpUserName", $$v)
                              },
                              expression: "myCorpModel.corpUserName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { padding: "0 10px" },
                          attrs: { span: 8 }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择部门",
                                size: "small"
                              },
                              model: {
                                value: _vm.myCorpModel.corpGroupId,
                                callback: function($$v) {
                                  _vm.$set(_vm.myCorpModel, "corpGroupId", $$v)
                                },
                                expression: "myCorpModel.corpGroupId"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" }
                              }),
                              _vm._l(_vm.department, function(item, i) {
                                return _c("el-option", {
                                  key: i,
                                  attrs: {
                                    label: item.groupName,
                                    value: item.corpGroupId
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: { "text-align": "end" },
                  attrs: { span: 3, push: 1 }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.queryToolMyCorp()
                        }
                      }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "tel-box",
              staticStyle: { height: "415px", overflow: "auto" }
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.myCorpModel.loading,
                      expression: "myCorpModel.loading"
                    }
                  ],
                  ref: "singleTableRef",
                  staticStyle: { width: "100%" },
                  attrs: {
                    "empty-text": _vm.myCorpModel.emptyText,
                    data: _vm.tableListMyCorp,
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                    stripe: "",
                    "cell-style": { cursor: "pointer" },
                    "header-cell-style": {
                      background: "#f9f9f9",
                      color: "#333333",
                      fontWeight: "500"
                    }
                  },
                  on: { "row-click": _vm.handleRowClickAuditAndCopy }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "账号", prop: "targetId" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "名称", prop: "userName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "部门", prop: "groupNames" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("br"),
          _c("el-pagination", {
            staticStyle: { "text-align": "right" },
            attrs: {
              "current-page": _vm.myCorpModel.itemPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.myCorpModel.pageSize,
              layout: "sizes, prev, pager, next, jumper, total",
              total: _vm.myCorpModel.total
            },
            on: {
              "size-change": _vm.handleSizeChangeQueryToolMyCorp,
              "current-change": _vm.handleCurrentChangeQueryToolMyCorp
            }
          }),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.ccToCorpUserVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.clickHandleAddAuditorOrCopyerSubmit()
                    }
                  }
                },
                [_vm._v("添加")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04a356b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a356b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/selectCcUser/index.vue
// module id = Kxts
// module chunks = 27 31 41 42